import { Form, Select } from "antd";
import { isEmpty } from "lodash";
import React from "react";
import { useController, useWatch } from "react-hook-form";
import { useSelector } from "react-redux";
import { checkHookFormFieldPropsEquality } from "./formValidatonRules";
import InfoForMultiSelect from "./InfoForMultiSelect";

const onMultiSelectHandler = (value, list, fieldName, onSelect, setValue) => {
  let newValue = value;
  if (value === 0) {
    newValue = list
      ? list.map((i) => {
          return i.Id;
        })
      : [];
    setValue(fieldName, newValue);
  }
  onSelect && onSelect(newValue);
};

const AgencyMultiSelectEx = (props) => {
  const { agencies, isLoading, InfoForMultiSelectExtraContent, InfoForMultiSelectParentStyle } = props;

  const {
    field,
    fieldState: { error, isTouched, isDirty },
  } = useController({
    name: props.name,
    control: props.control,
  });

  const propToWatch = useWatch({ control: props.control, name: props.name });

  const agenciesLoading = useSelector((state) => state.agency.loading);
  const onSelectHandler = (value) => {
    onMultiSelectHandler(
      value,
      agencies,
      props.name,
      props.onSelect,
      props.setValue
    );
  };

  return (
    <Content
      {...props}
      field={field}
      error={error}
      isTouched={isTouched}
      isDirty={isDirty}
      isLoading={isLoading}
      agenciesLoading={agenciesLoading}
      agencies={agencies}
      onSelectHandler={onSelectHandler}
      propToWatch={propToWatch}
      InfoForMultiSelectParentStyle={InfoForMultiSelectParentStyle}
      InfoForMultiSelectExtraContent={InfoForMultiSelectExtraContent}
    >
      {props.children}
    </Content>
  );
};

const Content = React.memo(
  (props) => {
    const { field, error, agencies, isLoading, agenciesLoading, InfoForMultiSelectParentStyle, InfoForMultiSelectExtraContent } = props;

    var inputProps = { ...props };
    delete inputProps.control;
    delete inputProps.formLabel;
    delete inputProps.layout;
    delete inputProps.required;
    delete inputProps.isTouched;
    delete inputProps.isDirty;
    delete inputProps.error;
    delete inputProps.field;
    delete inputProps.children;
    delete inputProps.formStyle;
    delete inputProps.autoFocus;
    delete inputProps.agenciesLoading;
    delete inputProps.isLoading;
    delete inputProps.agencies;
    delete inputProps.onSelectHandler;
    delete inputProps.propToWatch;
    delete inputProps.setValue;
    delete inputProps.InfoForMultiSelectParentStyle;
    delete inputProps.InfoForMultiSelectExtraContent;

    const agencyOptions = agencies
      ? agencies.map((a) => {
          return { label: a.FullName, value: a.Id };
        })
      : [];

    if (agencies && agencies.length > 1) {
      agencyOptions.unshift({
        label: `(Select all ${agencies.length} agencies)`,
        value: 0,
      });
    }

    return (
      <Form.Item
        {...props.layout}
        label={props.formLabel}
        name={props.name}
        validateStatus={error != null ? "error" : ""}
        help={error != null ? error.message : null}
        required={props.required}
        autoFocus={props.autoFocus}
        style={props.formStyle}
      >
        <div>
          <span
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            <Select
              {...field}
              {...inputProps}
              name={props.name}
              onChange={(v, o) => {
                let agencyValues = v;

                const isSelectAll =
                  v != null &&
                  v.length > 0 &&
                  (v[v.length - 1] === 0 || v.length > agencies.length);

                if (isSelectAll) {
                  agencyValues = agencies.map((i) => i.Id);
                }

                field.onChange(agencyValues, o);
                props.onChange?.(agencyValues);
                props.setValue?.(props.name, agencyValues, { shouldValidate: true }); // force update so that selecting all clears error
              }}
              options={agencyOptions}
              loading={agenciesLoading || isLoading || isEmpty(agencies)}
              onSelect={props.onSelectHandler}
              maxTagCount={4}
              allowClear={true}
              mode="multiple"
              showSearch
              virtual={false}
              optionFilterProp="label"
              filterOption={(input, option) => {
                const label = option.label ? option.label : option.children;
                return label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
              }}
            />
          </span>
          <div style={InfoForMultiSelectParentStyle}>
            <InfoForMultiSelect data={agencies} currentValue={props.propToWatch}/>
            {InfoForMultiSelectExtraContent}
          </div>
        </div>
      </Form.Item>
    );
  },
  (prevProps, nextProps) =>
    checkHookFormFieldPropsEquality(prevProps, nextProps) &&
    prevProps.agenciesLoading === nextProps.agenciesLoading &&
    prevProps.isLoading === nextProps.isLoading &&
    prevProps.agencies.length === nextProps.agencies.length &&
    prevProps.propToWatch === nextProps.propToWatch &&
    prevProps.InfoForMultiSelectExtraContent === nextProps.InfoForMultiSelectExtraContent
);

export default AgencyMultiSelectEx;
